import React, { useEffect, useState } from 'react'
import { SurgicalOrderLayout } from 'presentation/hospital/layouts/SurgicalOrder'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { ApiRepository } from 'repository/api-repository'
// import { RemoteLoadSurgeries } from 'service/usecases/load-surgeries/remote-load-surgeries'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
// import { RemoteUpdateSurgicalOrder } from 'service/usecases/update-surgical-order/remote-update-surgical-order'
import { RemoteLoadSurgicalOrder } from 'service/usecases/load-surgical-order/remote-load-surgical-order'
import { useHistory, useLocation } from 'react-router'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
// import { RemoteUploadSurgicalOrderDocument } from 'service/usecases/upload-surgical-order-document/remote-upload-surgical-order-document'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { toast } from 'react-toastify'
import UpdateSurgicalOrder from 'presentation/hospital/components/UpdateSurgicalOrder'
import { RemoteLoadSurgeryCenter } from 'service/usecases/load-surgery-center/remote-load-surgery-center'
import { RemoteLoadHealthInsurancePlans } from 'service/usecases/load-health-insurance-plans/remote-load-health-insurance-plans'
import { SurgeryCenterRepository } from 'repository/repositories/surgery-center/surgery-center-repository'
import { HealthInsuranceRepository } from 'repository/repositories/health-insurance/health-insurance-repository'
import { RemoteReorderSurgicalOrder } from 'service/usecases/reorder-surgery/remote-reorder-surgery'
import { RemoteLoadSurgicalOrderDocument } from 'service/usecases/load-surgical-order-document/load-upload-surgical-order-document'
import { GuidesModal } from 'presentation/hospital/components/GuidesModal'
import { HealthInsurancePlans } from 'domain/usecases/health-insurance/search-health-insurances'
import { RemoteSearchHealthInsurances } from 'service/usecases/search-health-insurances/remote-search-health-insurances'

const SurgicalOrder = WithLoading(({ setIsLoading }: WithLoadingProps) => {
  const history = useHistory()
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const [showRemakeModal, setShowRemakeModal] = React.useState<boolean>(false)
  const [showGuidesModal, setShowGuidesModal] = React.useState<boolean>(false)

  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)
  const loadSurgicalOrder = new RemoteLoadSurgicalOrder(surgicalOrderRepository)
  const surgeryCenterRepository = new SurgeryCenterRepository(apiRepository)
  const healthInsuranceRepository = new HealthInsuranceRepository(apiRepository)

  const loadSurgeryCenters = new RemoteLoadSurgeryCenter(
    surgeryCenterRepository
  )
  const loadHealthInsurances = new RemoteLoadHealthInsurancePlans(
    healthInsuranceRepository
  )
  const reorderSurgicalOrder = new RemoteReorderSurgicalOrder(
    surgicalOrderRepository
  )
  const loadSurgicalOrderDocument = new RemoteLoadSurgicalOrderDocument(
    surgicalOrderRepository
  )

  const searchHealthInsurances = new RemoteSearchHealthInsurances(
    healthInsuranceRepository
  )

  type SurgicalLocation = {
    id: number
    isSolicitation?: boolean
  }

  const location = useLocation<SurgicalLocation>()
  const [order, setOrder] = useState({} as SurgicalOrderModel)

  const [availableHealthInsurances, setAvailableHealthInsurances] = useState(
    [] as HealthInsurancePlans[]
  )

  async function loadData() {
    setIsLoading(true)
    try {
      const loadOrder = await loadSurgicalOrder.load(
        Number(location.state.id),
        [
          'doctor{name, doctor_id, crm, phone, email}',
          'patient{birthday, gender, company, name, cpf, email, lastName, phone, landlinePhone, maritalStatus,' +
            '}',
          'hospital{name, hospital_id}',
          'surgical_order_id',
          'createdAt',
          'expectedDate',
          'procedure {isMain,procedure_code,code,description,quantity,doctor_name, surgery_id, pro_fat_id}',
          'freeze',
          'healthInsurance {healthInsuranceCode, healthInsuranceName, healthPlanCode, healthPlanName, company, validThru, healthCard, healthSubPlanName, healthSubPlanCode}',
          'hospitalizationMode',
          'hospitalizationType',
          'cid {code, description}',
          'clinicalHistory',
          'technique',
          'laterality',
          'observation',
          'surgicalCenter',
          'room',
          'cti',
          'requestedDailies',
          'region',
          'patientHospitalized',
          'extraBlood',
          'allergy',
          'opme {solicitations {description, quantity}, providers}',
          // 'documents {document_id, type, name, documentUri}',
          'status {status }',
          'isSolicitation',
          'cooperative_name',
          'locale_hospitalization',
          'bullish_forecast_date',
          'anesthesiologies {anesthesiology_id, name}',
          'report_recommendation',
          'last_integration {date, name}'
        ]
      )
      setOrder(loadOrder)
    } catch (error: any) {
      toast.error('Ocorreu um erro ao carregar o pedido cirúrgico')
      history.push('/home')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  useEffect(() => {
    async function loadData() {
      setIsLoading(true)
      try {
        const response = await searchHealthInsurances.load({
          params: [
            `
              code
              description
              plans {
                code
                description
              }
              ansRegister
            `
          ],
          hospital_id: 1
        })

        setAvailableHealthInsurances(response)
      } catch (error: any) {
        toast.error('Houve um erro ao carregar os convênios')
      } finally {
        setIsLoading(false)
      }
    }

    loadData()
  }, [])

  if (order?.procedure) {
    return (
      <>
        <ContainerNew>
          <SurgicalOrderLayout
            isSolicitation={location.state?.isSolicitation}
            surgicalOrder={order}
            openRemakeModal={() => setShowRemakeModal(true)}
            openGuidesModal={() => setShowGuidesModal(true)}
            availableHealthInsurances={availableHealthInsurances}
          />
        </ContainerNew>

        {showRemakeModal && (
          <UpdateSurgicalOrder
            surgicalOrderId={Number(order.surgical_order_id) ?? 0}
            loadHealthInsurance={loadHealthInsurances}
            loadSurgeryCenters={loadSurgeryCenters}
            close={() => setShowRemakeModal(false)}
            reorderSurgicalOrder={reorderSurgicalOrder}
            loadSurgicalOrder={loadSurgicalOrder}
          />
        )}

        {showGuidesModal && (
          <GuidesModal
            surgicalOrderId={Number(order.surgical_order_id) ?? 0}
            close={() => setShowGuidesModal(false)}
            loadSurgicalOrder={loadSurgicalOrder}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
          />
        )}
      </>
    )
  } else return <></>
})

export default SurgicalOrder
